export default __webpack_public_path__ + "static/media/regulatory--no-stopping-on-pavement--g1.4ad4966b.png";